import React from "react";

const CTA = () => {
  return (
    <div className="cta">
      <a href="/assets/Axel_cv.pdf" download className="btn">
        Get my resume here
      </a>
      <a href="#contact" className="btn btn__primary">
        Get in touch
      </a>
    </div>
  );
};

export default CTA;
